import { useTranslation } from 'react-i18next';

import { useQuery } from '@tanstack/react-query';
import TrueCalendar from 'utils/TrueCalendar';

import { getKeyByValue } from '../utils/utils';

import { PUBLIC_API } from './constant/constant';
import { getApi } from './utils/utils';

import { LANGUAGES } from 'constants/languages';

export const useServerTime = () => {
  return useQuery({
    queryKey: ['server-time'],
    queryFn: () => getApi('/public/time'),
    staleTime: Infinity,
    onSuccess: (response) => {
      const serverTimeMs = response?.data?.data;
      if (serverTimeMs) TrueCalendar.updateTime(serverTimeMs);
    },
  });
};

const COMPANY_NAME = 'ZOGOFARM';
export const useFAQ = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['faq', currentLanguage],
    queryFn: () => {
      return getApi(`/public/faq/all?parentCompany=${COMPANY_NAME}&language=${currentLanguage}`);
    },
    onSuccess: () => {},
  });
};

export const useHowToPlay = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['how-to-play', currentLanguage],
    queryFn: () => {
      return getApi(`/public/config/how-to-play/${COMPANY_NAME}?language=${currentLanguage}`);
    },
    onSuccess: () => {},
  });
};

export const useAboutTheGame = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['about-the-game', currentLanguage],
    queryFn: () => {
      return getApi(`/public/config/about-the-game/${COMPANY_NAME}?language=${currentLanguage}`);
    },
    onSuccess: () => {},
  });
};

export const useCountries = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => {
      return getApi(PUBLIC_API.COUNTRY);
    },
    staleTime: Infinity,
    onSuccess: () => {},
  });
};

export const useStaticConfig = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['static-config', currentLanguage],
    queryFn: () => {
      return getApi(`/public/config/static-config/${COMPANY_NAME}?language=${currentLanguage}`);
    },
    onSuccess: () => {},
  });
};
